var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActionLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5883 19.005C13.0433 19.46 13.7783 19.46 14.2333 19.005L18.4217 14.8167C18.8767 14.3617 18.8767 13.6267 18.4217 13.1717L14.2333 8.98333C13.7783 8.52833 13.0433 8.52833 12.5883 8.98333C12.1333 9.43833 12.1333 10.1733 12.5883 10.6283L14.7817 12.8333H4.66667C4.025 12.8333 3.5 13.3583 3.5 14C3.5 14.6417 4.025 15.1667 4.66667 15.1667H14.7817L12.5883 17.36C12.1333 17.815 12.145 18.5617 12.5883 19.005ZM22.1667 3.5H5.83333C4.53833 3.5 3.5 4.55 3.5 5.83333V9.33333C3.5 9.975 4.025 10.5 4.66667 10.5C5.30833 10.5 5.83333 9.975 5.83333 9.33333V7C5.83333 6.35833 6.35833 5.83333 7 5.83333H21C21.6417 5.83333 22.1667 6.35833 22.1667 7V21C22.1667 21.6417 21.6417 22.1667 21 22.1667H7C6.35833 22.1667 5.83333 21.6417 5.83333 21V18.6667C5.83333 18.025 5.30833 17.5 4.66667 17.5C4.025 17.5 3.5 18.025 3.5 18.6667V22.1667C3.5 23.45 4.55 24.5 5.83333 24.5H22.1667C23.45 24.5 24.5 23.45 24.5 22.1667V5.83333C24.5 4.55 23.45 3.5 22.1667 3.5Z",
    fill: "#2BACE2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionLogout);
export default __webpack_public_path__ + "static/media/action-logout.efe8112e155ecf3645e530bc3b6f9d04.svg";
export { ForwardRef as ReactComponent };